import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {
    FormsModule,
    NgForm,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { AuthService } from 'app/core/auth/auth.service';
import {Api} from "../../../core/api/api";
import {CommonConstants} from "../../../core/constants/common-constants";
import {HelperService} from "../../../core/services/helper/helper.service";
import {SidemenuService} from "../../../../@fuse/services/sidemenu/sidemenu.service";
import { LABELS } from '../../../core/constants/label-constants';
import { environment } from 'environments/environment.prod';
import { MatDialog } from '@angular/material/dialog';
import { BrandTermPopupComponent } from 'app/modules/common/brand-term-popup/brand-term-popup.component';
import { BrandTermsService } from 'app/modules/admin/brand-terms/brand-terms.service';

@Component({
    selector: 'auth-sign-in',
    templateUrl: './sign-in.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        RouterLink,
        FuseAlertComponent,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
    ],
    providers:[AuthService, Api]
})
export class AuthSignInComponent implements OnInit{
    @ViewChild('signInNgForm') signInNgForm: NgForm;

    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    signInForm: UntypedFormGroup;
    showAlert: boolean = false;
    url: string = '';
    isAdmin: boolean = true;
    permissions = ['canAdd', 'canDelete', 'canEdit', 'canRead'];
    isPartner: boolean = false;
    details: any;
    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _authService: AuthService,
        private _formBuilder: UntypedFormBuilder,
        public _router: Router,
        private _helper: HelperService,
        private _sideMenuService: SidemenuService,
         public dialog: MatDialog,
         private _brandTermService: BrandTermsService
    ) {
        this.initializeLoginForm()     
         
        this.isPartner =  this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1; 
        if(window.location.origin.indexOf('admin.grimmor') !== -1){
            if(this.isPartner){
                this._router.navigate(['/']);
            }
        }
        if(window.location.origin.indexOf('partners.grimmor.com/partner') !== -1){
                this._router.navigate(['/']);
        }
        
    }

    getDetails(userData:any) {
        this._brandTermService.viewActive().subscribe((res: any) => {
            if (res?.meta?.status == 1) {
              this.details = res?.data;
              if(!userData?.isBrandTermsAccepted){
                const dialogRef = this.dialog.open(BrandTermPopupComponent, {
                    width: "1100px",
                    data: this.details,
                    disableClose: true
                    });
                    dialogRef.afterClosed().subscribe((result) => {
                    if (!result) return;
                        
                    })
                }
            } else {
                this._helper.toast(res?.meta?.message, 'error');
            }
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * Summary: Form initialize
     */
    initializeLoginForm() {
        let RememberMe: any = this._helper.getLocalStorageData(CommonConstants.REMEMBER_ME)
        let isRememberMeChecked = false;
        let password = null;
        let email = null;
        if (RememberMe && RememberMe?.rememberMe) {
            isRememberMeChecked = RememberMe.rememberMe;
            email = RememberMe.email;
            password = RememberMe.password;
        }

        this.url = this._router.url;
        // Create the form

        this.signInForm = this._formBuilder.group({
            rememberMe: [isRememberMeChecked],
            email: [email, [Validators.required, Validators.pattern(CommonConstants.EMAIL_REGEX)]],
            password: [password, [Validators.required, Validators.minLength(6), Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
        });
         
    }

    /**
     * On init
     */
    ngOnInit(): void {
      
        this._helper.setPageTitle(
            'Admin Sign In',
            'Partner Sign In'
        );
      
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign in
     */
    signIn(): void {
        // Return if the form is invalid
        if (this.signInForm.invalid) {
            return;
        }

        // Disable the form
        this.signInForm.disable();

        // Hide the alert
        this.showAlert = false;

        // Sign in
        this._authService.signIn(this.signInForm.value, this.isPartner).subscribe(
            (res: any) => {
                if(res?.meta?.status == 1){
                    this._helper.toast(res?.meta?.message, 'success');
                    if(this.isPartner){
                        if(res?.data?.isBrandTermsAccepted){
                            localStorage.setItem('brandTermAccepted', 'true')
                        }else{
                            localStorage.setItem('brandTermAccepted', 'false')
                        }
                        // this._router.navigate(['/partner/product-management'])
                           environment.production ? this._router.navigate(['/dashboard']) : this._router.navigate(['/partner/dashboard']) 
                        //    this.getDetails(res?.data); 
                           
                    } else{
                        this._router.navigate(['/dashboard'])
                    }
                } else {
                    this._helper.toast(res?.meta?.message, 'error');
                }
                // this._router.navigateByUrl(redirectURL);
            },
            (response) => {
                // Re-enable the form
                this.signInForm.enable();

                // Reset the form
                // this.signInNgForm.resetForm();

                // Set the alert
                this.alert = {
                    type: 'error',
                    message: 'Wrong email or password',
                };

                // Show the alert
                this.showAlert = true;
            }
        );
    }

    protected readonly LABELS = LABELS;
}
